import {useEffect} from 'react';

export default function useGrid() {
  useEffect(() => {
    // if (process.env.ENV === 'DEV') {
    //   const handleKeyDown = (e: KeyboardEvent) => {
    //     if (e.key === 'g') document.body.classList.toggle('grid');
    //   };
    //   window.addEventListener('keydown', handleKeyDown);
    //   return () => window.removeEventListener('keydown', handleKeyDown);
    // }
  }, []);
}
